// extracted by mini-css-extract-plugin
export default {"error":"bvd_k4jNvmehI3tnjbIy"};